import { computed, createBlock, openBlock, unref } from "vue";
import emptyImageSvg from "../../assets/3448554beb4b633a.svg";
import { imgUtils } from "../../plugins/banza/img.js";
import { VImg } from "vuetify/components/VImg";
const _sfc_main = {
  __name: "CustomImage",
  props: {
    image: {
      type: Object,
      default: null
    },
    height: {
      type: [String, Number],
      default: 600
    },
    cover: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "center"
    },
    alt: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const src = computed(() => {
      if (props.image) {
        return imgUtils.getPublicImgUrl(props.image.id, props.height);
      }
      return emptyImageSvg;
    });
    const alt = computed(() => {
      if (props.alt) {
        return props.alt;
      }
      if (props.image) {
        return props.image.name;
      }
      return "";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(VImg, {
        class: "gjs-portal-custom-image",
        src: unref(src),
        cover: __props.cover,
        position: __props.position,
        alt: unref(alt)
      }, null, 8, ["src", "cover", "position", "alt"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
